import Dexie from "dexie";

import { tests_complete } from "../../../api/v2/schemas/mg.schema.js";

declare global {
	interface Window {
		OfflineDexie: typeof OfflineDexie;
	}
}

export class OfflineDexie extends Dexie {
	async exportDB() {
		let allTests = await this.tests_complete.toArray();
		console.log(allTests.length);
		return allTests;
	}
	// Declare implicit table properties.
	// (just to inform Typescript. Instanciated by Dexie in stores() method)
	tests_complete!: Dexie.Table<tests_complete, number>; // number = type of the primkey
	static setuped = false;
	static emergency = false;
	static ready: Promise<boolean>;
	static resolve?: (value: boolean | PromiseLike<boolean>) => void;

	constructor(db?: string) {
		// delete old db
		// indexedDB.deleteDatabase("offline-v0");
		super(db || "offline-tests-v0");
		this.version(1).stores({
			tests_complete: "_id,tid,uid,pgid"
		});

		OfflineDexie.ready ||= new Promise<boolean>((resolve, reject) => {
			OfflineDexie.resolve = resolve;
		});
		if (OfflineDexie.setuped == false) {
			OfflineDexie.setuped = true;
			this.setup()
				.then(() => {
					OfflineDexie.resolve?.(true);
				})
				.catch(e => {
					OfflineDexie.emergency = true;
					console.error(":C", e);
					alert(`Parece que estas usando un navegador con características reducidas. Usa Google Chrome para no tener incovenientes al usar el servicio. REF. ${e}`);
					indexedDB.deleteDatabase("conectate");
					indexedDB.deleteDatabase("conectate-v2");
					indexedDB.deleteDatabase("conectate-v3");
				});
		}
	}

	async setup() {
		let countCountries = await this.tests_complete.count();
		this.tests_complete = this.table("tests_complete");
	}

	async getTestCompletebyUID(uid: string) {
		await OfflineDexie.ready;
		return await this.tests_complete.where({ uid: uid }).toArray();
	}

	async saveTestComplete(test: tests_complete) {
		await OfflineDexie.ready;
		return this.tests_complete.put(test);
	}

	deleteAll() {
		return this.tests_complete.clear();
	}
}
